import React, { createContext, useContext, useEffect, useState, useRef } from "react";
import { onAuthStateChanged, User, signInWithCustomToken, UserCredential } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { auth, functions } from "./firebaseConfig";
import { useNative } from "./NativeContext";

interface AuthContextType {
    user: User | null;
    userInit: boolean;
    signInUser: (phone: string) => Promise<void | UserCredential>;
    signOutUser: () => Promise<void>;
}

declare global {
    interface Window {
        confirmationResult: any;
    }
}

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const { isNative, postAuthToken } = useNative();
    const [user, setUser] = useState<User | null>(auth.currentUser);
    const [userInit, setUserInit] = useState<boolean>(false);

    // 웹뷰인 경우 로그인을 저장하지 못하기에
    // 네이티브에서 저정한 후 불러와
    // 다시 로그인하는 형태로 구현
    useEffect(() => {
        if (isNative) {
            const params = new URLSearchParams(window.location.search);
            const firebaseToken = params.get("firebaseToken");
            if (firebaseToken) {
                signInWithCustomToken(auth, firebaseToken);
            }
        }
    }, []);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUserInit(true);
            if (!currentUser) {
                setUser(null);
            } else {
                setUser(currentUser);
            }
            return;
        });

        return () => unsubscribe();
    }, [auth]);

    const signInUser = async (token: string) => {
        // postAuthToken(token);
        return signInWithCustomToken(auth, token).catch((err) => {
            console.log("Error at signInUser: ", err);
        });
    };

    const signOutUser = async () => {
        await auth.signOut();
    };

    // const devAccountSignIn = async () => {
    //     return httpsCallable(functions, "devAccount")().then((data: any) => {
    //         console.log(data.data);
    //         signInUser(data.data);
    //     });
    // };

    // useEffect(() => {
    //     devAccountSignIn();
    // });

    return (
        <AuthContext.Provider
            value={{
                user,
                userInit,
                signInUser,
                signOutUser,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
